<template>
  <v-card width="500" :elevation="dndCallOver ? 14 : 3"
    @dragover.prevent="dragOver" @dragleave.prevent="dragLeave"
    @drop.prevent="dndDrop">
    <v-card-title primary-title>
      <template v-if="disabled">
        <v-tooltip bottom light>
          <template v-slot:activator="{ on }">
            <v-icon color="warning" v-on="on" class="mr-2 pconf-title-icon">
              mdi-alert-circle
            </v-icon>
          </template>
          <span>{{ $t('confr.personal.disabledTooltip') }}</span>
        </v-tooltip>
      </template>
      <template v-else>
        <v-icon color="primary" class="mr-2 pconf-title-icon">
          mdi-account-group-outline
        </v-icon>
      </template>
      <span :class="{'orange--text': disabled}">
        {{ $t('confr.personal.title.card') }}
      </span>
      <v-spacer></v-spacer>

      <v-tooltip bottom light v-if="canRead">
        <template v-slot:activator="{ on }">
          <v-btn @click="config" fab x-small class="mr-1 config"
            dark depressed color="primary" v-on="on">
            <v-icon>mdi-cog-outline</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('confr.personal.settings.btnTooltip') }}</span>
      </v-tooltip>

      <CardTitleMenu :has-calls="hasCalls"
        :can-call="canWrite"
        :can-invite="canWrite"
        :conf-disabled="disabled"
        @call-room="$emit('call-room', dialExten)"
        @invite-member="$emit('invite-member')"
        @show-members="showMembers" />
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text v-if="conf">
      <v-row dense class="text-no-wrap">
        <v-col md="6">
          <v-icon small>mdi-card-account-phone</v-icon>
          {{ $t('confr.exten') }}: {{ dialExten }}
        </v-col>
        <v-col md="6">
          <v-icon small>mdi-account-switch</v-icon>
          {{ $t('confr.capacity') }}: {{ conf.maxusers }} members
        </v-col>
        <v-col md="6">
          <v-icon small>mdi-lock</v-icon>
          {{ $t('confr.pin') }}: {{ conf.pin }}
        </v-col>
        <v-col md="6" class="conf-member">
          <v-icon small>mdi-account-multiple-check</v-icon>
          {{ $t('confr.members') }}: {{ membersCount }}
        </v-col>
      </v-row>
    </v-card-text>
    <PersonalSettings @close="showSettings=false" :show="showSettings" />
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CardTitleMenu from './card_title_menu'
import PersonalSettings from './personal_settings'
export default {
  name: 'conferences-personal',
  data () {
    return {
      dndCallOver: false,
      showSettings: false,
      xferCallId: '',
      xferNumber: ''
    }
  },
  props: {
    conf: {
      type: Object,
      required: false
    }
  },
  components: { CardTitleMenu, PersonalSettings },
  computed: {
    ...mapGetters({
      canRead: 'permissions/personalConfRead',
      canWrite: 'permissions/personalConfWrite'
    }),
    disabled: function () {
      if (!this.conf) {
        return true
      }
      return this.conf?.isDisabled
    },
    dialExten: function () {
      return `*99${this.conf?.exten}`
    },
    hasCalls: function () {
      return this.membersCount > 0
    },
    membersCount: function () {
      return this.conf?.members?.length ?? 0
    }
  },
  methods: {
    ...mapActions({
      setActive: 'conferences/setActive',
      memPaneShow: 'conferences/memPaneShow'
    }),
    showMembers: function () {
      this.setActive(this.conf).then(() => {
        this.memPaneShow(true)
      })
    },
    config: function () {
      this.showSettings = true
    },
    dragOver: function (e) {
      // Personal conference transfer is not implemented in Back-End
      /*
      if (e.dataTransfer.types.includes('call/json')) {
        this.dndCallOver = true
      }
      */
    },
    dragLeave: function (e) {
      // Personal conference transfer is not implemented in Back-End
      /*
      this.dndCallOver = false
      */
    },
    dndDrop: function (e) {
      // Personal conference transfer is not implemented in Back-End
    }
  }
}
</script>

<style scoped>
</style>
